//Author Julie Ho
//Date 21st August 2025
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, putAPICallGenerator, deleteAPICallGenerator, callBackGenerator} from '../../util/util';
import {Button, Card, CardHeader, CardBody, Input, Row, Col} from 'reactstrap';
import DatePicker from 'react-datepicker';
import {NavLink, useParams} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
import UAD36Ready from './uad36-ready';
import moment from 'moment';

let today = new Date();
let month = today.getMonth()+1;

if(month<10)
  month = '0'+month;
let to = today.getFullYear()+'-'+month+'-'+today.getDate();

//initialize the state
const initialState = {
  valid: false
};

//reducer function that perform state update
const reducer = getReducer();


const UAD36ReadyV2  = (props)=>{
  const controller = new AbortController();

  let id = useParams().id;
  let email = useParams().email;
  let newInitialState = Object.assign({}, initialState, {
    id:id,
    email:email,
    UAD36Willing:'',
    UAD36Ready:'',
    UAD36ReadyDate:'',
    UAD36FutureWilling:'',   // NEW
  });

  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpPostNoToken = postAPICallGenerator(props, {signal:controller.signal, noToken:true});
 

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);


  //API call
  const updateProfile = ()=>{
    let parameters = [
      {
        field:'ID',
        value:state.id
      },
      {
        field:'email',
        value:state.email
      },
      {
        field:'UAD36Ready',
        value:state.UAD36Ready
      }
    ];

    if(state.UAD36ReadyDate!==''){
      parameters.push(
      {
        field:'UAD36ReadyDate',
        value:state.UAD36ReadyDate
      })
    }
    console.log(parameters)
    const callBack = apiCallBack([{state:'valid', value:true}]);
    httpPostNoToken('appraiser/uad36v2', parameters, 'Profile updated successfully.', 'Oops, something went wrong and could not update your profile. Please try again later.', callBack);
  }

  //render
  let UAD36ReadyDate;

  if(state.UAD36ReadyDate!=='')
    UAD36ReadyDate = moment(state.UAD36ReadyDate).toDate();

  let action;
  
    if(state.valid)
      action = <center>
        Dear Valued @home VMS Appraiser,<br/><br/>Thank you for your response to the UAD3.6 appraisal survey. Your profile has been updated to reflect the answer given.
        <br/>If you have any questions or concerns, please email service@homevms.com or call us at 415-614-3880 so we can assist you.
        <br/>Thank you, and have a great day!
      </center>
  
    let topBar;
  
    if(!props.isLoggedIn){
      topBar = <div className="topbar">
          <div className="topbar-logo-container">
            <NavLink to="/"><img className="topbar-logo-img" alt="@Home VMS Logo" width="120px" src="/img/logo_small.png"/></NavLink>
          </div>
      </div>;
  
  
    }
    console.log(state);
    return (
      <div>
        {topBar}
          
        <div className="padding">
          <Row>
            <Col sm="1">
  
            </Col>
            <Col sm="10">
              <Card style={{background:'#f5f5f5'}}>
                <CardHeader className="header-color">
                  <center>
                      <i className="fa fa-edit"></i>UAD 3.6 Ready
                  </center>
                </CardHeader>
                <CardBody>
                  {state.valid?<center>
                    Dear Valued @home VMS Appraiser,<br/><br/>Thank you for your response to the UAD3.6 appraisal survey. Your profile has been updated to reflect the answer given.
                    <br/>If you have any questions or concerns, please email service@homevms.com or call us at 415-614-3880 so we can assist you.
                    <br/>Thank you, and have a great day!
                  </center>:
                    <form id="uadSurvey" onSubmit={(e)=>{e.preventDefault();updateProfile()}}>
                    <div class="question">
                      <p><strong>Are you going to be accepting 3.6 assignments?</strong></p>
                      <Input required="true" type="select" onChange={(e)=>setState({UAD36Willing:e.target.value})}>
                        <option key=""></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </Input>

                    </div>
                    {
                      state.UAD36Willing && state.UAD36Willing==='yes'?
                      <div>
                        <p><strong>Are you ready to accept 3.6 assignments now?</strong></p>
                        <Input required="true" type="select" onChange={(e)=>{
                          setState({UAD36Ready:e.target.value})
                          if(e.target.value==='yes')
                            setState({UAD36ReadyDate:to})
                        }}>
                          <option value=""></option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Input>
                      </div>
                      :null
                    }
                    {
                      (state.UAD36Willing && state.UAD36Willing==='no')?
                      <div>
                        <p><strong>Do you anticipate accepting 3.6 assignments in the future?</strong></p>
                        <Input required="true" type="select" onChange={(e)=>{
                          setState({UAD36FutureWilling:e.target.value})
                          if(e.target.value==='no')
                            setState({UAD36ReadyDate:''})
                          setState({UAD36Ready:'no'})
                        }}>
                          <option value=""></option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Input>
                      </div>
                      :null
                    }
                    {
                      (state.UAD36Willing==='yes' && state.UAD36Ready==='no')||(state.UAD36FutureWilling==='yes')?
                      <div>
                        <p><strong>When are you ready to accept 3.6 assignments?</strong></p>
                        <DatePicker
                          className="form-control"
                          dateFormat='dd MMM yyyy'
                          selected={UAD36ReadyDate}
                          onChange={(text)=>setState({UAD36ReadyDate:moment(text).format("YYYY-MM-DD")})}
                        />
                      </div>
                      :null
                    }
                
                    <br/>
                    <div className="align-right">
                      <Button color="warning" type="submit">Submit</Button>
                    </div>
                  </form>                  
                  }
                  
                  <br/>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }


export default UAD36ReadyV2;
